import {
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

export default function QuestionDialog({ onClose, question, questions }) {
  const selected_question = questions.find((q) => q.name === question);

  const question_dimensions = {
    teacher_question: "Lehrer*innen",
    expert_question: "Beobachter*innen",
    student_question: "Schüler*innen",
  };

  const handleClose = () => {
    onClose();
  };

  if (questions && question)
    return (
      <Dialog onClose={handleClose} open={Boolean(question)}>
        <DialogTitle>Fragen bei {selected_question.title}</DialogTitle>
        <DialogContent>
          <List>
            {Object.keys(question_dimensions).map((question_dimension) => (
              <ListItem key={question_dimension}>
                <ListItemText
                  primary={question_dimensions[question_dimension]}
                  secondary={selected_question[question_dimension]}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>
    );

  return;
}
